var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProjectLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "White",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_288",
    "data-name": "Path 288",
    d: "M1860.866,284.191a7.624,7.624,0,0,0-6.952-6.952v-2.572h-1.27v2.572a7.625,7.625,0,0,0-6.952,6.952h-2.571v1.27h2.571a7.624,7.624,0,0,0,6.952,6.952v2.572h1.27v-2.572a7.623,7.623,0,0,0,6.952-6.952h2.572v-1.27Zm-1.27,1.27a6.358,6.358,0,0,1-5.682,5.682v-2.507h-1.27v2.507a6.359,6.359,0,0,1-5.682-5.682h2.508v-1.27h-2.508a6.36,6.36,0,0,1,5.682-5.682v2.508h1.27v-2.508a6.359,6.359,0,0,1,5.682,5.682h-2.507v1.27Z",
    transform: "translate(-1841.121 -272.667)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_635",
    "data-name": "Rectangle 635",
    width: 24,
    height: 24,
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectLocation);
export default __webpack_public_path__ + "static/media/ProjectLocation.6009a972.svg";
export { ForwardRef as ReactComponent };